import React, { useState } from 'react';
import BusinessCardIcon from '../../../assets/images/BusinessCardIcon';

export default function ImageUploadField({ imagePreview, onImageUpload, onImageRemove }) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
    const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    if (file && file.type && file.type.startsWith('image/')) {
      onImageUpload({ target: { files: [file] } });
    }
  };

  return (
    <div className="w-full">
      {imagePreview ? (
        <div className="relative bg-gray-800/50 backdrop-blur border border-gray-700/50 rounded-3xl p-4 mb-6">
          <img src={imagePreview} alt="Preview" className="max-h-64 mx-auto rounded-lg shadow-lg" />
          <button
            onClick={onImageRemove}
            className="absolute top-2 right-2 bg-red-600 hover:bg-red-700 text-white rounded-full p-2 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      ) : (
        <div>
          <input
            type="file"
            id="image-upload"
            accept="image/*"
            onChange={onImageUpload}
            className="hidden"
          />
          <label
            htmlFor="image-upload"
            onDragEnter={handleDragOver}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            className={`flex flex-col items-center justify-center w-full min-h-[160px] backdrop-blur rounded-3xl cursor-pointer transition-all duration-300 mb-6 px-6 py-6 border-2 border-dashed ${
              isDragging
                ? 'bg-gray-800/40 border-violet-400 ring-2 ring-violet-400/40'
                : 'bg-gray-800/60 border-gray-600 hover:border-violet-500 hover:bg-gray-700/50'
            }`}
          >
            <div className="mb-4 bg-gradient-to-br from-blue-400 to-purple-400 p-1.5 rounded-2xl inline-block">
              <BusinessCardIcon className="w-40 h-24 text-white" />
            </div>
            {isDragging ? (
              <p className="text-white text-lg font-semibold text-center">
                Drop the image to upload
              </p>
            ) : (
              <>
                <p className="text-white text-lg font-semibold text-center">
                  Upload a business card
                </p>
                <p className="text-gray-300 text-sm text-center">
                  Drag & drop or click to choose
                </p>
                <p className="text-gray-400 text-xs text-center mt-2">
                  JPG, PNG, HEIC · up to 10MB
                </p>
              </>
            )}
          </label>
        </div>
      )}
    </div>
  );
}

